import { configureStore } from '@reduxjs/toolkit'
import storeLogin from './storeLogin'

export default configureStore({
  reducer: {
    storeLogin
  }
})